<script lang="ts" setup>
import instanceNotification, { NotificationTab } from '@/assets/ts/notification'
import DateFns from '@/legacy/ts/dateFns'
import getTextFromConsole from '@/legacy/ts/getTextFromConsole'
import { getMcrRootUrl } from '@/lib/siteBaseUrl'

const props = defineProps({
	isLoading: {
		type: Boolean,
		default: false,
	},
	itemInfo: {
		type: Object,
		default: null,
	},
})

function toDateTime(timestamp: number | null) {
	if (timestamp === null) return ''

	return new DateFns().formatDate(
		timestamp * 1000,
		getTextFromConsole('notification_date_format').toString(),
		window.BUYANDSHIP.settings.current_language,
	)
}

function toNotificationUrl() {
	instanceNotification.updateListEach(props.itemInfo.id).then(() => {
		window.location.href = `${getMcrRootUrl()}${props.itemInfo.url}`
	})
}
</script>

<template>
	<div
		@click="toNotificationUrl"
		:class="[
			'bs-notification-list-item',
			{ 'bs-notification-list-item--skeleton': isLoading },
		]"
	>
		<template v-if="isLoading">
			<div class="bs-notification-list-item__icon">
				<div class="bs-card__skeleton bs-card__skeleton--line"></div>
			</div>
			<div class="bs-notification-list-item__info">
				<div class="bs-notification-list-item__info__title">
					<div class="bs-card__skeleton bs-card__skeleton--line"></div>
				</div>
				<div class="bs-notification-list-item__info__content">
					<div class="bs-card__skeleton bs-card__skeleton--line"></div>
				</div>
				<div class="bs-notification-list-item__info__timestamp">
					<div class="bs-card__skeleton bs-card__skeleton--line"></div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="bs-notification-list-item__icon">
				<span
					v-if="!itemInfo.isRead"
					class="bs-notification-list-item__icon--dot"
				></span>
				<i
					:class="[
						`bs-icon bs-icon--${
							NotificationTab[itemInfo.type as keyof typeof NotificationTab]
						}`,
					]"
				></i>
				<div></div>
			</div>
			<div class="bs-notification-list-item__info">
				<div class="bs-notification-list-item__info__title">
					{{ itemInfo.title }}
				</div>
				<div class="bs-notification-list-item__info__content">
					{{ itemInfo.content }}
				</div>
				<div class="bs-notification-list-item__info__timestamp">
					{{ toDateTime(itemInfo.createdTimestamp) }}
				</div>
			</div>
		</template>
	</div>
</template>
